import { render, staticRenderFns } from "./PortalCollapse.vue?vue&type=template&id=a497928e&scoped=true&"
import script from "./PortalCollapse.vue?vue&type=script&lang=ts&"
export * from "./PortalCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./PortalCollapse.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PortalCollapse.vue?vue&type=style&index=1&id=a497928e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a497928e",
  null
  
)

export default component.exports